import * as React from "react";
const SvgFiRrMapMarkerHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-map-marker-home_svg__a)">
      <path
        fill="#062147"
        d="M12 0a11 11 0 0 0-7.75 18.806l3.943 3.641a5.44 5.44 0 0 0 7.593.02l3.992-3.689A11 11 0 0 0 12 0m6.392 17.337-3.984 3.681A3.513 3.513 0 0 1 9.57 21l-3.935-3.636A9 9 0 1 1 21 11a8.92 8.92 0 0 1-2.608 6.337M16.71 7.663l-3-2.081a3.01 3.01 0 0 0-3.42 0l-3 2.081A3 3 0 0 0 6 10.128V13.5A2.5 2.5 0 0 0 8.5 16h7a2.5 2.5 0 0 0 2.5-2.5v-3.372a3 3 0 0 0-1.29-2.465M16 13.5a.5.5 0 0 1-.5.5H14v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2H8.5a.5.5 0 0 1-.5-.5v-3.372a1 1 0 0 1 .43-.822l3-2.081a1.01 1.01 0 0 1 1.14 0l3 2.081a1 1 0 0 1 .43.822z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-map-marker-home_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMapMarkerHome;
